


export const BlockOne = {

    Title : "Commercial kitchen just got safer",
    Body : "S&P USA is excited to introduce Kitchen Hoods to our line of commercial ventilation products! Our Kitchen Hoods utilize heavy gauge materials and construction techniques to create an end product that is more rigid and easier to install. These hoods are recommended for most cooking applications from light to extra heavy cooking loads.",
    ButtonLink : "/Kitchen-Hoods",
    Button : "Discover Here",
    Img : 'https://solerpalau-usa.com/images/pages/homepage/KitchenHoods-blocl.webp',

};

export const BlockTwo = {

    Title : "Low Profile with EC motor now available",
    Body : "With a growing demand for smaller and more flexible units, S&P USA has added the Total Recovery Low Profile with EC motor (TRLPe) to our Total Recovery (TR) series. Designed to fit tight spaces, the TRLPe110 (corded) & TRLPe110H (hardwired) are the perfect Energy Recovery Ventilators (ERVs) for light commercial buildings, multi-family homes, and residences with low ceilings.",
    ButtonLink : "/Energy-Recovery-Ventilators",
    Button : "Learn More",
    Img : 'https://solerpalau-usa.com/images/pages/homepage/trple110.webp',
    
    };

export const BlockThree = {

    Title : "Discover the latest in our PC Series",
    Body : "Premium CHOICE Low Profile Exhaust Fan with DC Motor is designed to fit in the smallest wall cavities, making it a versatile and convenient solution for Mixed-Use & Multi-Family applications.",
    ButtonLink : "/In-line-and-Sidewall-Duct-Fans",
    Button : "View Here",
    Img : 'https://solerpalau-usa.com/images/pages/homepage/pclpd100xhp.webp',
        
    };  


export const FooterData = {

    TitleOne : "Soler & Palau Ventilation Group",
    DiscCanada : "CANADA - 6710 Maritz Drive, Unit 7, Mississauga, ON L5W 0A1",
    DiscUSA : "USA - 6393 Powers Avenue, Jacksonville, FL 32217",
    IconLinkOne : "",
    IconLinkTwo : "",
    IconLinkThree : "",
    TitleTwo: "Quick Links",
    Link1: "/about-us",
    Link2: "/products",
    Link3: "/Newsroom",
    Link4: "/",
    name1: "About Us",
    name2: "Products",
    name3: "Newsroom",
    name4: "Resources",
    TitleThree: "Newsletter",
    DiscSub: "Subscribe now for latest detals and news",
    CTA: "/",
    CTADDisc: "Sign Up",
    Copyright1: "Copyright © 2017-2022 JencoFan",
    Copyright2: "All Rights Reserved",
    Footerlogo: require("../../assests/footer-logo.webp"),
    PolicyLink: "/",
    Policyname: "Privacy Policy",
    WMLink: "/",
    WMname: "Website Map",
    SMLink: "/",
    SMname: "Site Map", 



}    
        
        

